import React from 'react';
import { HashLink } from 'react-router-hash-link';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="dark-section border-t border-gold-500/20">
      <div className="max-w-6xl mx-auto px-6 py-10 md:py-14">
        {/* Top area */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Brand */}
          <div className="text-center md:text-left flex flex-col items-center md:items-start">
            <Logo variant="light" size="md" showTagline />
          </div>

          {/* Links */}
          <div className="text-center">
            <h4 className="font-sans text-base md:text-lg font-semibold text-gold-400 tracking-wider uppercase mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <HashLink
                  to="/#hero"
                  smooth
                  className="font-body text-cream-300/70 hover:text-gold-400 transition-colors text-base md:text-lg"
                >
                  Home
                </HashLink>
              </li>
              <li>
                <HashLink
                  to="/#services"
                  smooth
                  className="font-body text-cream-300/70 hover:text-gold-400 transition-colors text-base md:text-lg"
                >
                  Services
                </HashLink>
              </li>
              <li>
                <HashLink
                  to="/contact#contact"
                  className="font-body text-cream-300/70 hover:text-gold-400 transition-colors text-base md:text-lg"
                >
                  Contact
                </HashLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center md:text-right">
            <h4 className="font-sans text-base md:text-lg font-semibold text-gold-400 tracking-wider uppercase mb-4">
              Connect
            </h4>
            <a
              href="https://ca.linkedin.com/in/bentleygurparmbrar"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-cream-300/70 hover:text-gold-400 transition-colors text-base md:text-lg"
            >
              <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              LinkedIn
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gold-500/10 pt-6 text-center">
          <p className="font-body text-cream-300/40 text-sm">
            Copyright &copy; {new Date().getFullYear()} Marquee Commodity
            Group. All rights reserved.
          </p>
          <p className="font-body text-cream-300/30 text-sm mt-2 italic">
            Marquee operates strictly as an independent corporate advisory
            platform. All regulated securities activity is performed by duly
            licensed third-party professionals.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
